export default "__VITE_ASSET__CCe2Q0IA__"